import { useRef } from "react";
import { Icon } from "../../components/Icon";
import { formatDate } from "../../lib/orders";
import { useClientDocs, useUploadClientDoc } from "../../lib/useClients";

function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} КБ`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
}

export function ClientDocsTab({ clientId }: { clientId: string }) {
  const { data, isLoading } = useClientDocs(clientId);
  const upload = useUploadClientDoc(clientId);
  const fileRef = useRef<HTMLInputElement>(null);
  const docs = data ?? [];

  const onPick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) upload.mutate({ file, label: file.name });
    e.target.value = "";
  };

  return (
    <>
      <input
        ref={fileRef}
        type="file"
        hidden
        aria-label="Файл документа"
        onChange={onPick}
      />
      <div className="cd-doc-grid">
        {isLoading && <p className="muted">Загрузка…</p>}
        {docs.map((d) => (
          <div key={d.id} className="cd-doc-card">
            <div className="cd-doc-thumb">
              <div className="cd-doc-blur">
                <span>🛂</span>
                <p>{d.label}</p>
              </div>
            </div>
            <div className="cd-doc-meta">
              <p className="cd-doc-label">
                {d.label}
                {d.verified && <span className="cd-verified">✓ верифиц.</span>}
              </p>
              <p className="cd-doc-sub">
                Загружен {formatDate(d.uploadedAt)} · {formatSize(d.sizeBytes)}
              </p>
            </div>
          </div>
        ))}
        <button
          className="cd-doc-add"
          disabled={upload.isPending}
          onClick={() => fileRef.current?.click()}
        >
          <Icon name="upload" size={22} />
          <span>{upload.isPending ? "Загрузка…" : "Загрузить документ"}</span>
        </button>
      </div>
    </>
  );
}
